import { memo, useMemo } from "react";
import { Colors } from "../../utils/colors";
import { FoldHeaderText } from "./SubComponents/FoldHeaderText";
import CarouselContainer, {
  CarouselItem,
} from "../AnimationContainers/CarouselContainer";
import { StoopDatingCarousel } from "../../assets/LandingPage/Carousel/TopCarousel/topCarouselIndex";
import RealResultsComedyStoreLogo from "../../assets/LandingPage/MainPage/RealResultsComedyStore.png";
import RealResultsSeaav from "../../assets/LandingPage/MainPage/RealResultsSeaav.png";

type RealResultsFoldProps = {
  isDesktopSize: boolean;
};

const MOBILE_CARD_WIDTH = 366;

type ResultCardParams = {
  image: string;
  imageFit: "cover" | "contain";
  label: string;
  stat: string;
  statSubtext: string;
};

const renderResultCard = (params: ResultCardParams, isDesktopSize: boolean) => {
  const { image, imageFit, label, stat, statSubtext } = params;
  return (
    <div
      key={label}
      style={{
        position: "relative",
        flex: isDesktopSize ? 1 : "none",
        width: isDesktopSize ? undefined : MOBILE_CARD_WIDTH,
        height: isDesktopSize ? 600 : 500,
        borderRadius: 20,
        overflow: "hidden",
        backgroundColor: Colors.GRAY10,
        backgroundImage: `url(${image})`,
        backgroundSize: imageFit,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          height: "30%",
          backgroundImage:
            "linear-gradient(180deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%)",
        }}
      />
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: "25%",
          backgroundImage:
            "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 45%, rgba(0,0,0,0.96) 75%, rgba(0,0,0,1) 100%)",
        }}
      />
      <div
        className="ColumnNormalSpaced"
        style={{
          position: "relative",
          height: "100%",
          padding: 26,
          boxSizing: "border-box",
          textAlign: "left",
        }}
      >
        <span style={{ fontSize: 32, fontWeight: 500, color: Colors.WHITE }}>
          {label}
        </span>
        <div className="ColumnNormal" style={{ gap: 6 }}>
          <span style={{ fontSize: 60, fontWeight: 600, color: Colors.WHITE }}>
            {stat}
          </span>
          <span style={{ fontSize: 18, fontWeight: 500, color: Colors.WHITE }}>
            {statSubtext}
          </span>
        </div>
      </div>
    </div>
  );
};

const RealResultsFold = (props: RealResultsFoldProps) => {
  const { isDesktopSize } = props;

  const cards: ResultCardParams[] = useMemo(
    () => [
      {
        image: RealResultsComedyStoreLogo,
        imageFit: "cover",
        label: "Business",
        stat: "90K+",
        statSubtext:
          "Text subscriber growth in 15 months with Markit automations",
      },
      {
        image: StoopDatingCarousel,
        imageFit: "cover",
        label: "Creator",
        stat: "10x",
        statSubtext: "New text subscribers since using Markit",
      },
      {
        image: RealResultsSeaav,
        imageFit: "cover",
        label: "Brand",
        stat: "30%",
        statSubtext: "conversion rate on Instagram comments to text list",
      },
    ],
    []
  );

  const carouselItems: CarouselItem[] = useMemo(
    () =>
      cards.map((card) => ({
        image: card.image,
        title: "",
        width: MOBILE_CARD_WIDTH,
        alternateItem: renderResultCard(card, false),
      })),
    [cards]
  );

  return (
    <div
      className="ColumnCentering"
      style={{
        gap: isDesktopSize ? 80 : 40,
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        paddingBlock: isDesktopSize ? 80 : 60,
        backgroundImage:
          "radial-gradient(ellipse 140% 60% at top, #112c65 0%, #04070d 45%, #000000 70%)",
      }}
    >
      <FoldHeaderText
        isDesktopSize={isDesktopSize}
        addGradient
        textStyles={{
          alignSelf: isDesktopSize ? "center" : "flex-start",
          paddingInline: isDesktopSize ? 0 : 20,
        }}
      >
        Real results
      </FoldHeaderText>
      {isDesktopSize ? (
        <div
          className="AlignedRow slide-up"
          style={{ gap: 24, width: 1152, paddingInline: 20 }}
        >
          {cards.map((card) => renderResultCard(card, true))}
        </div>
      ) : (
        <CarouselContainer
          carouselItems={carouselItems}
          dark
          enableSwipe
          showMulti
          pauseOnHover
          containerStyles={{ width: "100%" }}
          hideFadedGradient
        />
      )}
    </div>
  );
};

export default memo(RealResultsFold);
